<template>
  <el-form
      label-position="left"
      ref="form"
      :model="form"
      :disabled="disabledForm"
      class="form"
      size="mini">
    <el-table size="mini"
              border
              :data="serviceRevenue"
              style="width: 100%; margin-top: 10px;">
      <el-table-column
          label="No."
          width="80"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="`${serviceRevenueKey}.` + scope.$index + '.no'">
            <el-input v-model="scope.row.no"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          v-if="(serviceRevenueKey === 'serviceRevenue' && typeOfSale === 'isSSI') || (serviceRevenueKey === 'salesServiceItems')"
          label="Item Name"
          width="160"
          align="center">
        <template slot-scope="scope">
          <el-form-item
              :prop="`${serviceRevenueKey}.` + scope.$index + '.itemId'"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                v-model="scope.row.itemId"
                size="mini"
                @change="(id) => selectItem(id, scope.row)">
              <el-option
                  v-for="item in accountsRevenue"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          v-else
          :label="otherRevenue ? 'Account' : serviceRevenueKey === 'salesServiceItems' ? 'Service Item' : 'Revenue Account'"
          width="160"
          align="center">
        <template slot-scope="scope">
          <el-form-item
              :prop="`${serviceRevenueKey}.` + scope.$index + '.revenueAccount'"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                v-model="scope.row.revenueAccount"
                :placeholder="serviceRevenueKey === 'salesServiceItems' ? 'Select Service Item' : 'Account'"
                size="mini"
                @change="(id) => selectItem(id, scope.row)"
            >
              <el-option
                  v-for="item in accountsRevenue"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Details"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="`${serviceRevenueKey}.` + scope.$index + '.description'">
            <el-input placeholder="Details" v-model="scope.row.description" size="mini"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Unit Price"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-form-item
              label-width="0"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.price'"
              :rules="{
                          required: true, message: 'Field is required', trigger: 'blur'
                        }">
            <money v-model="scope.row.price" :disabled="disabledForm" @keydown.native="$event.key === '-' ? $event.preventDefault() : null" v-bind="money" @change.native="countTotalAmount(scope.row)"></money>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Unit"
          align="center"
          width="110">
        <template slot-scope="scope">
          <el-form-item
              :prop="`${serviceRevenueKey}.` + scope.$index + '.unit'"
              placeholder="Unit"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                v-model="scope.row.unit"
                size="mini">
              <el-option
                  v-for="item in units"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Qty"
          align="center"
          width="70">
        <template slot-scope="scope">
          <el-form-item :prop="`${serviceRevenueKey}.` + scope.$index + '.qty'">
            <el-input placeholder="Qty" type="number" v-model="scope.row.qty" size="mini" @input="countTotalAmount(scope.row)"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          v-if="form.allowDiscounts === 'isLine'"
          label="Discount"
          align="center"
          width="200">
        <el-table-column
            align="center"
            width="100">
          <template slot-scope="scope">
            <el-form-item
                :prop="`${serviceRevenueKey}.` + scope.$index + '.scpwdDiscountRate'"
                placeholder="Unit"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
              <el-select
                  v-model="scope.row.scpwdDiscountRate"
                  size="mini">
                <el-option
                    v-for="item in lumpsumDiscountRates"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="100">
          <template slot-scope="scope">
            <el-form-item
                :prop="`${serviceRevenueKey}.` + scope.$index + '.discountAmount'"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
              <el-input placeholder="Amount" type="number" v-model="scope.row.discountAmount" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
          label="Total Amount"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-form-item
              label-width="0"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.totalAmount'"
              :rules="{
                          required: true, message: 'Field is required', trigger: 'blur'
                        }">
            <money v-model="scope.row.totalAmount" :disabled="disabledForm" v-bind="money" readonly></money>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Tax Code"
          align="center"
          width="180">
        <template slot-scope="scope">
          <el-form-item
              label-width="0"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.taxCode'"
              :rules="{
                          required: true, message: 'Field is required', trigger: 'blur'
                        }">
            <el-select
                v-model="scope.row.taxCode"
                size="mini"
                :disabled="form.amountsAre === 1"
                clearable
                @change="alertTax"
                @clear="() => scope.row.taxRate = 0">
              <el-option
                  v-for="item in salesTaxList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <span style="float: left">{{ item.codeTax }}</span>
                  <span style="padding-left: 10px; float: left; color: #8492a6; font-style: italic;">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          v-if="form.amountsAre !== 1"
          label="Tax Rate"
          align="center"
          width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.taxCode">{{scope.row.taxRate = setTaxRate(scope.row) }}%</div>
        </template>
      </el-table-column>
      <el-table-column
          v-if="form.allowDiscounts === 'isSCPWD'"
          label="SC/PWD"
          align="center"
          width="80">
        <template slot-scope="scope">
          <el-form-item
              label-width="0"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.isScPwd'">
            <el-checkbox v-model="scope.row.isScPwd"></el-checkbox>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Allocated To"
          align="center"
          width="130">
        <template slot-scope="scope">
          <el-form-item
              style="margin-bottom:0;"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.entityTypeId'"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                v-model="scope.row.entityTypeId"
                size="mini"
                placeholder="Type"
                @change="selectEntityType(scope)">
              <el-option
                  v-for="item in scope.row.entityTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Warehouse"
          align="center"
          width="120">
        <template slot-scope="scope">
          <el-form-item
              v-if="scope.row.entityTypeId === 4"
              style="margin-bottom:0;"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.warehouseId'"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                v-model="scope.row.warehouseId"
                :disabled="scope.row.entityTypeId !== 4"
                size="mini"
                placeholder="Warehouse"
                @change="selectWh(scope)">
              <el-option
                  v-for="item in scope.row.whList"
                  :key="item.id"
                  :label="item.warehouseName"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="BU"
          align="center"
          width="120">
        <template slot-scope="scope">
          <el-form-item
              style="margin-bottom:0;"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.buId'"
              :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                v-model="scope.row.buId"
                :disabled="!scope.row.entityTypeId || scope.row.entityTypeId === 4"
                size="mini"
                placeholder="BU"
                @change="selectBu(scope)">
              <el-option
                  v-for="item in scope.row.buList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="WHS-ENG-PRO"
          align="center"
          width="130">
        <template slot-scope="scope">
          <el-form-item
              style="margin-bottom:0;"
              v-if="scope.row.entityTypeId !== 2">
            <el-select
                v-model="scope.row.parentId"
                :disabled="!scope.row.buId"
                size="mini"
                placeholder="WHS-ENG-PRO"
                @change="selectParent(scope)">
              <el-option
                  v-for="item in scope.row.parentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Task"
          align="center"
          width="110">
        <template slot-scope="scope">
          <el-form-item
              style="margin-bottom:0;"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.taskId'">
            <el-select
                v-model="scope.row.taskId"
                :disabled="!scope.row.taskList.length"
                size="mini"
                placeholder="Task">
              <el-option
                  v-for="item in scope.row.taskList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="EU"
          align="center"
          width="130">
        <template slot-scope="scope">
          <el-form-item
              style="margin-bottom:0;"
              :prop="`${serviceRevenueKey}.` + scope.$index + '.userId'">
            <el-select
                v-model="scope.row.userId"
                :disabled="!scope.row.buId || !scope.row.entityTypeId"
                size="mini"
                placeholder="EU">
              <el-option
                  v-for="item in scope.row.userList"
                  :key="item.userId"
                  :label="item.userFullName"
                  :next-icon="false"
                  :value="item.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          width="170">
        <template slot-scope="scope">
          <div>
            <el-button
                size="mini"
                type="primary"
                plain
                @click="$emit('addNewItem')">Add line</el-button>
            <el-button
                v-if="serviceRevenue.length !== 1"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                plain
                @click="$emit('removeItem', scope.$index)"></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import { Money } from 'v-money'
import axios from "axios";

export default {
  name: "CRServiceRevenueTable",
  components: {
    Money
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    accountsRevenue: {
      type: Array,
      default: () => ([])
    },
    units: {
      type: Array,
      default: () => ([])
    },
    lumpsumDiscountRates: {
      type: Array,
      default: () => ([])
    },
    salesTaxList: {
      type: Array,
      default: () => ([])
    },
    // entityTypeList: {
    //   type: Array,
    //   default: () => ([])
    // },
    serviceRevenue: {
      type: Array,
      default: () => ([])
    },
    otherRevenue: {
      type: Boolean,
      default: false,
    },
    serviceRevenueKey: {
      type: String,
      default: 'serviceRevenue'
    },
    disabledForm: {
      type: Boolean,
      default: false
    },
    typeOfSale: {
      type: String,
      default: 'isSDtoSRA'
    }
  },
  data() {
    return {
      money: {
        precision: 2,
        decimal: '.',
        thousands: ','
      },
    }
  },
  methods: {
    alertTax(value) {
      if (value === 2149) {
        this.$alert('Please note that you are trying to use this tax on this form, but you might be mistaken. Please check again.', 'Alert', {
          confirmButtonText: 'OK',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        });
      }
    },
    countTotalAmount(row) {
      if (row.qty && !isNaN(row.price)) {
        row.totalAmount = row.qty * row.price
      } else {
        row.totalAmount = 0
      }
    },
    setTaxRate(row) {
      const tax = this.salesTaxList.find(tax => tax.id === row.taxCode)
      const taxRate = tax ? tax.valueTax : null
      this.$emit('calculateResults')
      return taxRate
    },
    async selectEntityType(scope) {
      const loader = this.$loading.show();
      scope.row.warehouseId = null
      scope.row.buId = null
      scope.row.parentId = null
      scope.row.taskId = null
      scope.row.userId = null
      scope.row.whList = []
      scope.row.buList = []
      scope.row.parentList = []
      scope.row.taskList = []
      scope.row.userList = []
      if (scope.row.entityTypeId === 4) {
        await this.getWarehouses(scope.row)
      }
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const response = await axios.post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
        scope.row.buList = response.data.list
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async selectWh(scope) {
      const wh = scope.row.whList.find(val => val.id === scope.row.warehouseId)
      scope.row.buId = wh.businessUnit.id
      scope.row.buList = [wh.businessUnit]
      scope.row.parentId = wh.project ? wh.project.id : null
      scope.row.parentList = wh.project ? [wh.project] : []
      scope.row.taskId = null
      scope.row.userId = null
      scope.row.taskList = []
      scope.row.userList = []
    },
    async selectBu(scope) {
      scope.row.parentId = null
      scope.row.taskId = null
      scope.row.userId = null
      scope.row.parentList = []
      scope.row.taskList = []
      scope.row.userList = []
      try {
        const loader = this.$loading.show();
        console.log(scope)
        switch (scope.row.entityTypeId) {
          case 1:
            axios.get(`/api/v1/businessUnits/projectsListBU?businessUnitId=${scope.row.buId}`).then(response => {
              console.log('---', response.data)
              scope.row.parentList = response.data.list
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 2:
            axios.post(`/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}`).then(response => {
              console.log('---', response.data)
              const list = response.data.newList
              list.shift()
              scope.row.taskList = list
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 3:
            axios.get(`/api/v1/businessUnits/engagementsListBU?businessUnitId=${scope.row.buId}`).then(response => {
              console.log('---', response.data)
              scope.row.parentList = response.data.list
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break
        }
      } catch (err) {
        console.log(err)
      }
      if (scope.row.entityTypeId === 2) {
        // business units
        await this.getParentUsers(scope)
      }
    },
    async selectParent(scope) {
      const loader = this.$loading.show();
      scope.row.taskId = null
      scope.row.taskList = []
      scope.row.userId = null
      scope.row.userList = []
      try {
        let url = ''
        switch (scope.row.entityTypeId) {
          case  1:
            url = `/api/v1/projectTasks/list?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}`
            break;
          case 2:
            url = `/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.parentId}`
            break;
          case 3:
            url = `/api/v1/engagementTasks/list?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}`
            break
        }

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.post(url)
        loader.hide()
        const list = data.newList ? data.newList : data.newlist
        list.shift()
        scope.row.taskList = list
      } catch (err) {
        loader.hide()
        console.log(err)
      }
      this.getParentUsers(scope)
    },
    async selectTask(scope) {
      scope.row.userId = null
      scope.row.userList = []
      const loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        switch (scope.row.entityTypeId) {
          case 1:
            axios.post(`/api/v1/projectTasks/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}&projectTaskId=${scope.row.taskId}`).then(response => {
              scope.row.userList = response.data.extendedInfo.projectTaskCompanyUserList
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 2:
            axios.post(`/api/v1/businessUnitTasks/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}&businessUnitTaskId=${scope.row.taskId}`).then(response => {
              scope.row.userList = response.data.extendedInfo.businessUnitTaskCompanyUserList
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 3:
            axios.post(`/api/v1/engagementTasks/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}&engagementTaskId=${scope.row.taskId}`).then(response => {
              scope.row.userList = response.data.extendedInfo.engagementTaskCompanyUserList
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getParentUsers(scope) {
      const loader = this.$loading.show();
      switch (scope.row.entityTypeId) {
        case 3: // ENG
          axios.post(`/api/v1/engagements/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}`).then(response => {
            console.log('response', response)
            scope.row.userList = response.data.extendedInfo.engagementCompanyUserList
            loader.hide()
          }).catch(err => {
            loader.hide()
          })
          break
        case 2: // BU
            axios.post(`/api/v1/businessUnits/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId  || scope.row.parentId}`).then(response => {
              console.log('response', response)
              scope.row.userList = response.data.extendedInfo.businessUnitCompanyUserList
              loader.hide()
            }).catch(err => {
              loader.hide()
            })
          break
        case 1: // Project
            axios.post(`/api/v1/projects/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}`).then(response => {
              console.log('response', response)
              scope.row.userList = response.data.extendedInfo.projectCompanyUserList
              loader.hide()
            }).catch(err => {
              loader.hide()
            })
          break
      }
    },
    async selectItem(id, row) {
      const item = this.accountsRevenue.find(val => val.id === id)
      if (item) {
        row.no = item.code
        row.price = item.sellPrice
        row.taxCode = item.sellTaxAccountId
        row.description = item.sellDescription
        row.unit = item.unitId
        if (item.accountTypeId && item.accountTypeId === 30) {
          row.discountAccountId = item.accountTypeId
        } else {
          row.discountAccountId = null
        }

        if (item.sellAccountId) row.sellAccountId = item.sellAccountId
        // check inventory itemsTypeId = 3
        if (item.itemsTypeId === 3) {
          row.entityTypeList = row.entityTypeList.filter(val => val.id === 4)
          // row.entityTypeId = item.itemsTypeId
          row.entityTypeId = 4
          row.inventoryAssetAccountId = item.inventoryAssetAccount.id
          row.purchaseAccountId = item.purchaseAccount.id
          row.costPrice = item.purchasePrice
          await this.getWarehouses(row)
          // load warehouse list
        }

        if (this.form.amountsAre === 1) {
          const noTax = this.salesTaxList.find(tax => tax.noTax)
          const noTaxSP = this.salesTaxList.find(tax => tax.noTaxSP)
          // row.taxCode = noTax ? noTax.id : null
          // row.taxCode = noTaxSP ? noTaxSP.id : null
          if (this.serviceRevenueKey === 'salesDirectToNonRevenues') {
            row.taxCode = noTax ? noTax.id : null
          } else {
            row.taxCode = noTaxSP ? noTaxSP.id : null
          }
        }
      }
    },
    async getWarehouses(row) {
      try {
        const { data } = await axios.post(`/api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
        row.whList = data.inventoryList
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>

</style>